// extracted by mini-css-extract-plugin
export default {"container":"public-share-cta-SharePopover__container--2A2cD","dark_icons":"public-share-cta-SharePopover__dark_icons--3q5Bk"};